import { createSelector } from 'reselect';
import { LayoutType } from '../../../types/layouts.esm.js';
import { createDisplayLayoutSelector } from '../../selectors/display-layout-selector.esm.js';
import { createLayoutListOptionsSelector } from './layout-list-options-selector.esm.js';

function getCurrentLayoutId(options, layout) {
  var result;
  switch (layout.type) {
    case LayoutType.Default:
    case LayoutType.Custom:
      result = options.find(function (o) {
        return o.type === layout.type;
      });
      break;
    default:
      result = options.find(function (o) {
        return o.type === layout.type && o.id === layout.id;
      });
      break;
  }
  if (result === undefined) {
    throw new Error("Cannot find layout ".concat(layout.id));
  }
  return result;
}
var createCurrentLayoutIdSelector = function createCurrentLayoutIdSelector() {
  var layoutListOptionsSelector = createLayoutListOptionsSelector();
  var displayLayoutSelector = createDisplayLayoutSelector();
  return createSelector(layoutListOptionsSelector, displayLayoutSelector, getCurrentLayoutId);
};

export { createCurrentLayoutIdSelector, getCurrentLayoutId };
//# sourceMappingURL=current-layout-id-selector.esm.js.map
